import { ApiBoardImageLoad } from "@/api";
import { canv } from "@/canv/global.js";
import {
    isImageFormatValid,
    isImageResolutionValid,
    isImageSizeValid,
    prepareImage,
} from "@/canv/utils";
import {
    IMAGE_FORMATS,
    IMAGE_FORMATS_READABLE,
    MAX_IMAGE_HEIGHT,
    MAX_IMAGE_SIZE_READABLE,
    MAX_IMAGE_WIDTH,
} from "@/constants.js";
import { GifWidget } from "@/elements/gif";
import { createImage, imageWidget } from "@/elements/image";
import { showSnackbar } from "@/snackbar/snackbar";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

const SNACKBAR_TIME = 5000;

export class WmMedia extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.options = options;
    }

    build() {
        return `
            <div class="wm_media">
               ${this.viewUrl}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_media");
        item?.removeEventListener("click", this.imageSelect, false);
        item?.addEventListener("click", this.imageSelect, false);
    }

    imageSelect = () => {
        const div = document.createElement("div");
        div.classList.add("imageWidgetInput");
        document.body.prepend(div);

        div.innerHTML = `
            <input 
                type="file" 
                style="display:none" 
                class="imageWidgetInputInput" 
                accept="${IMAGE_FORMATS.join(",")}"
            >
        `;

        const imageWidgetInput = document.querySelector<HTMLInputElement>(".imageWidgetInputInput");
        if (imageWidgetInput) {
            imageWidgetInput.click();

            imageWidgetInput.removeEventListener("change", this.imageWidgetInputChange, false);
            imageWidgetInput.addEventListener("change", this.imageWidgetInputChange, false);

            imageWidgetInput.outerHTML = "";
        }
    };

    imageWidgetInputChange = async (e: Event) => {
        const input = e.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }
        if (!isImageSizeValid(file.size)) {
            showSnackbar(`Размер изображения превышает лимит в ${MAX_IMAGE_SIZE_READABLE}`, {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }
        if (!isImageFormatValid(file.type)) {
            showSnackbar(`Допустимые форматы изображения: ${IMAGE_FORMATS_READABLE.join(", ")}`, {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }
        const tempImage = await prepareImage(file);
        if (!tempImage) {
            return;
        }
        if (!isImageResolutionValid(tempImage.width, tempImage.height)) {
            showSnackbar(
                `Изображение превышает допустимое разрешение ${MAX_IMAGE_WIDTH} x ${MAX_IMAGE_HEIGHT}`,
                {
                    duration: SNACKBAR_TIME,
                    type: "warning",
                },
            );
            return;
        }
        const widgetsToUpdate: (GifWidget | imageWidget)[] = [];
        if (
            this.options.some((option) => {
                const widget = canv.canvasController.FindByUID(option.UID);
                if (widget instanceof GifWidget || widget instanceof imageWidget) {
                    widgetsToUpdate.push(widget);
                }
                return widget instanceof GifWidget && file.type !== "image/gif";
            })
        ) {
            showSnackbar("Вы можете заменить это изображение только на GIF", {
                duration: SNACKBAR_TIME,
                type: "warning",
            });
            return;
        }

        widgetsToUpdate.forEach((widget) => widget.setLoading(true));

        return ApiBoardImageLoad(file)
            .then(async (json) => {
                const image = await createImage(json.path);
                widgetsToUpdate.forEach((widget) => {
                    widget.setLoading(false);
                });
                return this.imageOnLoad(image, json.path);
            })
            .catch((err) => {
                showSnackbar(err.toString(), {
                    duration: SNACKBAR_TIME,
                    type: "warning",
                });
                widgetsToUpdate.forEach((widget) => {
                    widget.setLoading(false);
                });
                console.log("ошибка загрузки картинки", err);
                return;
            });
    };

    imageOnLoad(img: HTMLImageElement, url: string) {
        const data = {
            src: url,
            obj: img,
        };

        return this.applyValue(this.options, data);
    }

    name = "wm_media";
    options: widgetOption<string>[] = [];
    viewUrl = `
            <svg width="23" height="23" viewBox="0 0 111 110" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_801_6" fill="white">
            <rect x="1" width="110" height="110" rx="5"/>
            </mask>
            <rect x="1" width="110" height="110" rx="5" fill="white" stroke="black" stroke-width="14" mask="url(#path-1-inside-1_801_6)"/>
            <path d="M3.33813 78.3964L30.9346 48.2553" stroke="black" stroke-width="7"/>
            <line x1="30.1624" y1="52.2479" x2="100.162" y2="107.248" stroke="black" stroke-width="7"/>
            <circle cx="81" cy="40" r="12" fill="white" stroke="black" stroke-width="6"/>
            </svg>
        `;
}
